import Phaser from 'phaser';
import { ModalSheet } from './modal-sheet';
import { ModalSheetConfig } from './modal-sheet/modal-sheet.types';

export class MilestonesSheet<TemplateData> extends ModalSheet<TemplateData> {
  constructor(
    scene: Phaser.Scene,
    config: ModalSheetConfig<TemplateData> = {},
  ) {
    super(scene, { ...config, iconKey: 'stadium' });
  }
  protected createContent(content: Phaser.GameObjects.Container): void {
    const element = this.createDomContent('milestones', this.cfg.templateData);

    content.add([element]);
  }
}
